import "primevue/resources/themes/bootstrap4-light-blue/theme.css"
import 'jquery/dist/jquery'
import 'bootstrap/dist/js/bootstrap'
import "@lottiefiles/lottie-player"
import 'primeflex/primeflex.css';
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';
import DynamicDialog from 'primevue/dynamicdialog';
import DialogService from 'primevue/dialogservice';
import Dropdown from 'primevue/dropdown';
import ProgressSpinner from 'primevue/progressspinner';
import Image from 'primevue/image';
import FileUpload from 'primevue/fileupload';
import DataTableBackend from 'asdecode-datatable/src/components/AsdecodeTable.vue';
import Editor from "primevue/editor";
import InputNumber from 'primevue/inputnumber';
import AutoComplete from 'primevue/autocomplete';
import ProgressBar from 'primevue/progressbar';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Chart from 'primevue/chart';
import SelectButton from 'primevue/selectbutton';
import SpeedDial from 'primevue/speeddial';
import MultiSelect from 'primevue/multiselect';
import ExportTable from "@/components/ExportTable.vue";
import AddResource from '@/components/AddResource.vue';
import YamsTemplate from '@/layouts/YamsTemplate.vue'
import YamsTemplateConfig from '@/layouts/YamsTemplateConfig.vue'
import { FormatService } from '@/services/FormatService';
import Pusher from 'pusher-js';


//parametres cors et la base url des requetes dans la spa
axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = store.getters.apiUrl

// Configuration des timeouts et des réponses par défaut
axios.defaults.timeout = 30000; // 30 secondes avant timeout
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Ajout d'un écouteur pour détecter les changements de connectivité
window.addEventListener('online', () => {
  store.dispatch('checkNetworkStatus');
});

window.addEventListener('offline', () => {
  store.dispatch('checkNetworkStatus');
});

// Initialiser l'état de la connexion au chargement
store.dispatch('checkNetworkStatus');

// Fonction pour vérifier la connectivité réseau
const checkNetworkConnection = () => {
  return navigator.onLine;
};

//si l'utilisateur s'est déjà connecté
const mysession = window.localStorage.getItem("yamsmanager_session")

if (mysession !== null) {
  const userDatas = JSON.parse(mysession);
  store.commit('setAuthenticated', userDatas);
  axios.defaults.headers.common = {
    'Authorization': 'Bearer ' + userDatas.token
  }

  // Surcharge globale de fetch
  const originalFetch = window.fetch.bind(window)

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {

    // Convertir les headers existants en objet
    const originalHeaders = init?.headers instanceof Headers
      ? Object.fromEntries(init.headers.entries())
      : (init?.headers || {})

    const modifiedInit: RequestInit = {
      ...init,
      headers: {
        ...originalHeaders,
        'Authorization': userDatas.token ? `Bearer ${userDatas.token}` : '',
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }

    return originalFetch(input as RequestInfo, modifiedInit)
  }
  // Configuration pour les requêtes d’authentification des channels privés/présence
  // Pusher.logToConsole = true

  const pusher = new Pusher("829d13f31922516e15fd", {
    cluster: "eu",
    authEndpoint: store.getters.apiUrl + "/broadcasting/auth",
    auth: {
      headers: {
        Authorization: 'Bearer ' + userDatas.token,
        Accept: "application/json"
      }
    }
  })

  // S'abonner à un channel de présence
  const presenceChannel = pusher.subscribe('presence-app')

  presenceChannel.bind('pusher:subscription_succeeded', (members: any) => {
    console.log('Utilisateurs connectés :', members)
    // members.each(callback) pour itérer
  })

  presenceChannel.bind('pusher:member_added', (member: any) => {
    console.log(member.info.name + "s'est connecté")
  })

  presenceChannel.bind('pusher:member_removed', (member: any) => {
    console.log(member.info.name + "s'est connecté")
  })

  // Écoute d’un event personnalisé
  presenceChannel.bind('refresh', (data: any) => {
    console.log("Nouvelle donnée reçue :", data)
  })


}

// Intercepteur de requête unique
axios.interceptors.request.use(
  config => {
    if (!navigator.onLine) {
      store.commit('setNetworkError', 'Pas de connexion Internet. Veuillez vérifier votre connexion réseau.');
      return Promise.reject(new Error('Pas de connexion Internet'));
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Intercepteur de réponse unique et amélioré
axios.interceptors.response.use(
  response => response,
  error => {
    // Récupérer les informations sur l'erreur
    const originalRequest = error.config;

    // Vérifier si c'est une erreur d'authentification 401
    if (error.response && error.response.status === 401) {
      store.commit('clearUserData'); // Déconnecter l'utilisateur
      router.push({ name: 'login' }); // Rediriger vers la page de connexion
      return Promise.reject(error);
    }

    // Vérifier s'il s'agit d'une erreur réseau et si la requête n'a pas déjà été retentée
    if ((error.message === 'Network Error' || !error.response) && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Afficher un message à l'utilisateur via le toast
      if (app && app.config.globalProperties.$toast) {
        app.config.globalProperties.$toast.add({
          severity: 'warn',
          summary: 'Problème de connexion',
          detail: 'Tentative de reconnexion au serveur...',
          life: 3000
        });
      }
      
      // Utiliser l'action de réessai du store
      return store.dispatch('retryFailedRequest', originalRequest);
    }

    // Pour les autres types d'erreurs
    console.error('Erreur Axios:', error.message || 'Erreur inconnue');
    return Promise.reject(error);
  }
);

const app = createApp(App);
app.use(VueAxios, axios)
app.provide('axios', axios)
app.use(PrimeVue)
app.use(store)
app.use(router)
app.use(DialogService)
app.use(ToastService)
app.component('YamsTemplate', YamsTemplate);
app.component('YamsTemplateConfig', YamsTemplateConfig);
app.component('DataTable', DataTable);
app.component('DataTableColumn', Column);
app.component('DataPaginator', Paginator);
app.component('DynamicDialog', DynamicDialog);
app.component('SearchDropdown', Dropdown);
app.component('ProgressSpinner', ProgressSpinner);
app.component('ShowImage', Image);
app.component('FileUpload', FileUpload);
app.component('TextEditor', Editor);
app.component('InputNumber', InputNumber);
app.component('AutoComplete', AutoComplete);
app.component('ProgressBar', ProgressBar);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('ShowToast', Toast);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('ChartJS', Chart);
app.component('SelectButton', SelectButton);
app.component('SpeedDial', SpeedDial);
app.component('MultiSelect', MultiSelect);
app.component('DataTableBackend', DataTableBackend);
app.component('ExportTable', ExportTable);
app.component('AddResource', AddResource);

// Ajout des fonctions globales
app.config.globalProperties.$moneyFormat = FormatService.moneyFormat;
app.config.globalProperties.$dateFormat = FormatService.dateFormat;
//pusher 
// Mettre Pusher dans les propriétés globales
// app.config.globalProperties.$pusher = Pusher;

app.mount('#app')